export const infosPratiquesData = [
  {
    title: "Adresse",
    icon: "ri-map-pin-2-line",
    items: [
      "Moorea-Maiao 98728",
      "Polynésie française"
    ]
  },
  {
    title: "Services",
    icon: "ri-service-line",
    items: [
      "Terrasse",
      "Repas sur place",
      "Service à table",
      "Bar sur place"
    ]
  },
  {
    title: "Parking",
    icon: "ri-parking-box-line",
    items: [
      "Stationnement facile",
      "Gratuit",
      "Sur place"
    ]
  },
  {
    title: "Accessibilité PMR",
    icon: "ri-wheelchair-line",
    items: [
      "Entrée accessible",
      "Parking accessible",
      "Places accessibles",
      "Toilettes accessibles"
    ]
  },
  {
    title: "Familles & Groupes",
    icon: "ri-group-line",
    items: [
      "Adapté aux familles",
      "Chaises hautes disponibles",
      "Menu enfant",
      "Groupes bienvenus",
      "Dîner en solo"
    ]
  },
  {
    title: "Paiements",
    icon: "ri-bank-card-line",
    items: [
      "Cartes crédit/débit",
      "Paiement mobile NFC",
      "Chèques acceptés"
    ]
  },
  {
    title: "Réservations",
    icon: "ri-calendar-check-line",
    items: [
      "Réservations acceptées",
      "+689 87 73 55 94"
    ]
  },
  {
    title: "Atmosphère",
    icon: "ri-heart-line",
    items: [
      "Décontracté",
      "Convivial",
      "Calme",
      "LGBTQ+ friendly 🌈"
    ]
  },
  {
    title: "Spécialités",
    icon: "ri-restaurant-line",
    items: [
      "Cuisine locale",
      "Poissons frais",
      "Cocktails maison",
      "Café & desserts"
    ]
  }
];